//Duration at or after which a button press will be considered as long press
export const longPressDuration = 700;
//Dialpad buttons for which long press will be handled
export const longPressHandledValues = ['*', '0'];